import {FC, useEffect, useState} from "react";
import {useNewUserContext, UserContext} from "../../store/userContext.ts";
import {getUser} from "../../api/user.ts";
import {Route, Routes, useNavigate} from "react-router";
import FullPageLoader from "../../templates/FullPageLoader.tsx";
import UserOnboardingPage from "./UserOnboardingPage.tsx";
import DashboardIndex from "./dashboard";
import LogoutPage from "./LogoutPage.tsx";

const UserIndex: FC = () => {
    const userContext = useNewUserContext();
    const navigate = useNavigate();
    const [userLoaded, setUserLoaded] = useState(false);

    useEffect(() => {
        if (userContext.user) {
            return
        }

        getUser().then(user => {
            userContext.setUser(user);

            if (!user) {
                navigate("/")
                return
            }

            setUserLoaded(true);
            if (!user.name) {
                console.log("Navigating to onboarding")
                navigate("/u/onboarding")
                return
            }

            if (user.sites.length === 0) {
                navigate("/u/dashboard/create-site")
                return
            }
            navigate("/u/dashboard/site/" + user.sites[0].siteId)
        })
    }, [userContext])

    if (!userContext.user) {
        return <FullPageLoader />
    }

    return <UserContext.Provider value={userContext}>
        <Routes key={userContext.user?.id || "no-user"}>
            <Route index element={<div>{JSON.stringify(userContext.user)}</div>} />
            <Route path="/onboarding" element={<UserOnboardingPage />} />
            <Route path="/logout" element={<LogoutPage />} />
            <Route path="/dashboard/*" element={userLoaded ? <DashboardIndex /> : <FullPageLoader />} />
            <Route path="*" element={<div>User Routes: Not found</div>} />
        </Routes>
    </UserContext.Provider>
}

export default UserIndex;